<template>
  <div class="d-contents">
    <v-skeleton-loader
      v-if="!get(incomingTenderListsInfo, 'results.length', false)"
      type="table-tbody"
    />
    <div v-else class="d-contents">
      <IncomingTenderListNavigation />
      <div :id="TABLES_IDS.INCOMING_TENDER_TABLE_ID" class="tender-list-wrapper">
        <!-- С помощью :key делаем рефреш таблицы при возникших ошибках и когда
        требуется рефреш на респонсах, чтобы поддерживать таблицу всегда в
        актуальном состоянии   -->
        <div :key="refreshIncomingTableTrigger" class="tender-list incoming-tender-list">
          <IncomingTenderListHeader
            :show-labour-material-tools="showLabourMaterialTools"
            :currency="incomingTenderInfo.currency"
          />
          <IncomingTenderListRow
            v-for="(row, rowIndex) in incomingTenderListsInfo.results"
            :key="row.id"
            :class="{
              'not-display': hiddenRows.includes(row.id),
            }"
            :is-turn-over-arrow="isTurnOverArrow(row)"
            :row-index="rowIndex"
            :row="row"
            :column-keys="columnKeys"
            :show-labour-material-tools="showLabourMaterialTools"
            :selected-version="selectedVersion"
            :order-of-rows-ids="orderOfRowsIds"
            @click.native="toggleNestedRows(row, computedRows)"
            @open-comments="handleCommentsOpen(row)"
          />
          <IncomingTenderListFooter
            v-if="get(incomingTenderListsInfo, 'list_sums')"
            :list-sums="incomingTenderListsInfo.list_sums"
            :currency="incomingTenderInfo.currency"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import get from 'lodash.get';
  import { VSkeletonLoader } from 'vuetify/lib';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import IncomingTenderListHeader from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListHeader';
  import IncomingTenderListRow from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListRow';
  import nestedRowsStructure from '@/utils/mixins/nested-rows-structure';
  import IncomingTenderListNavigation from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListNavigation';
  import IncomingTenderListFooter from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListFooter';
  import TenderPositionCard from '@/containers/tender/position/TenderPositionCard';
  import { changeQuery, deleteQuery } from '@/utils/router';
  import TABLES_IDS from '@/utils/constants/tables-ids';

  export default {
    name: 'IncomingTenderList',
    components: {
      IncomingTenderListFooter,
      IncomingTenderListNavigation,
      IncomingTenderListRow,
      IncomingTenderListHeader,
      VSkeletonLoader,
    },
    mixins: [nestedRowsStructure],
    data() {
      return {
        incomingTenderListId: this.$route.params.incomingTenderListId,
        TABLES_IDS,
      };
    },
    computed: {
      ...mapState('incomingTender', [
        'incomingTenderInfo',
        'incomingTenderListsInfo',
        'refreshIncomingTableTrigger',
        'selectedVersionId',
      ]),
      ...mapGetters('incomingTender', ['selectedVersion']),
      showLabourMaterialTools() {
        return !!this.incomingTenderInfo?.tender?.is_advanced_pricing_enabled;
      },
      columnKeys() {
        if (this.showLabourMaterialTools) {
          return [
            {
              title: 'labour',
              canBeEdited: this.showLabourMaterialTools,
            },
            {
              title: 'materials',
              canBeEdited: this.showLabourMaterialTools,
            },
            {
              title: 'tools',
              canBeEdited: this.showLabourMaterialTools,
            },
            {
              title: 'total',
              canBeEdited: !this.showLabourMaterialTools,
            },
            {
              title: 'labour_total',
              canBeEdited: false,
            },
            {
              title: 'materials_total',
              canBeEdited: false,
            },
            {
              title: 'tools_total',
              canBeEdited: false,
            },
            {
              title: 'total_total',
              canBeEdited: false,
              isSticky: true,
            },
          ];
        } else {
          return [
            {
              title: 'total',
              canBeEdited: !this.showLabourMaterialTools,
            },
            {
              title: 'total_total',
              canBeEdited: false,
              isSticky: true,
            },
          ];
        }
      },
      computedRows() {
        return this.incomingTenderListsInfo.results;
      },
      // Список айдишников строк, по которым можно производить навигацию стрелочками и табом,
      // исключает родительские групповые строки, скрытые строки и строки с брейкдауном (их нельзя редачить)
      orderOfRowsIds() {
        return this.computedRows
          .filter(
            (row) =>
              !row.row.group_level &&
              !row.breakdown_rows.length &&
              !this.hiddenRows.includes(row.id)
          )
          .map((row) => row.id);
      },
      positionRowsCount() {
        return this.incomingTenderListsInfo?.count;
      },
    },
    methods: {
      get,
      ...mapMutations('incomingTender', ['clearIncomingTenderListsInfo']),
      ...mapActions('modal', ['openModal']),
      ...mapActions('incomingTender', [
        'loadIncomingTenderListsInfo',
        'loadIncomingTenderVersions',
        'setChangesFromCustomer',
      ]),
      handleCommentsOpen(row) {
        let currentList = this.incomingTenderInfo.lists.find(
          (list) => list.id == this.$route.params.incomingTenderListId
        );

        changeQuery({
          position: row.id,
        });

        this.openModal({
          component: TenderPositionCard,
          context: {
            attributes: {
              class: ['create-tender__container'],
            },
            row: row.row,
            rowId: row.id,
            isIncomingTender: true,
            tenderTeam: get(this.incomingTenderInfo, 'tender.team.name', ''),
            tender: {
              title: get(this.incomingTenderInfo, 'tender.name', ''),
              list: get(currentList, 'title', ''),
            },
          },
        });
      },
    },
    watch: {
      // Если знаешь как норм тригериться на обновления параметра урла (переключение листов), то пингани мне
      '$route.params.incomingTenderListId': async function (id) {
        this.incomingTenderListId = id;
        await this.loadIncomingTenderListsInfo({
          listId: this.incomingTenderListId,
          offerVersionId: this.selectedVersionId,
        });
        this.nestedRowsStructure = null;
        this.hiddenRows = [];
      },
    },
    async created() {
      const incomingTenderId = this.$route.params.incomingTenderId;
      const versionId = this.$route.query?.version || null;
      await this.loadIncomingTenderVersions({
        incomingTenderId,
        updateSelectedVersion: true,
        versionId,
      });

      const positionId = this.$route.query?.position || null;
      if (positionId) {
        let positionRow = this.incomingTenderListsInfo.results.find((row) => row.id === positionId);
        if (positionRow) this.handleCommentsOpen(positionRow);
      }

      await deleteQuery(['version']);
    },
    beforeDestroy() {
      this.setChangesFromCustomer(false);
    },
    destroyed() {
      this.clearIncomingTenderListsInfo();
    },
  };
</script>
